import api from '../api/axios';
import { StoryImagePlanEntity } from '../types/entities';

const BASE = process.env.REACT_APP_BASE_API_URL || process.env.REACT_APP_API_URL || '';
const withBase = (path: string) => `${BASE}${path}`;

export const getPlansByRunId = async (runId: string) => {
  const res = await api.get(withBase(`/story-image-plans/by-runid/${runId}`));
  return res.data as StoryImagePlanEntity[];
};

export const getPlanById = async (id: string) => {
  const res = await api.get(withBase(`/story-image-plans/${id}`));
  return res.data as StoryImagePlanEntity;
};

export const updatePlan = async (id: string, body: Partial<StoryImagePlanEntity>) => {
  const res = await api.patch(withBase(`/story-image-plans/${id}`), body);
  return res.data as StoryImagePlanEntity;
};

export const uploadUserImage = async (planId: string, file: File | Blob, orderIndex?: number) => {
  const fd = new FormData();
  fd.append('file', file);
  if (typeof orderIndex === 'number') fd.append('orderIndex', String(orderIndex));
  const res = await api.post(withBase(`/story-image-plans/${planId}/upload-user-image`), fd, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return res.data as StoryImagePlanEntity;
};

export const clearUserImage = async (planId: string) => {
  const res = await api.post(withBase(`/story-image-plans/${planId}/clear-user-image`), {});
  return res.data as StoryImagePlanEntity;
};

export const createFromAi = async (planId: string, orderIndex?: number) => {
  const body: any = {};
  if (typeof orderIndex === 'number') body.orderIndex = orderIndex;
  const res = await api.post(withBase(`/story-image-plans/${planId}/create-from-ai`), body);
  return res.data as StoryImagePlanEntity;
};

export const recombineTts = async (planId: string) => {
  const res = await api.post(withBase(`/story-image-plans/${planId}/recombine-tts`), {});
  return res.data as { id: string; audioUrl: string };
};

const storyImagePlanService = {
  getPlansByRunId,
  getPlanById,
  updatePlan,
  uploadUserImage,
  clearUserImage,
  createFromAi,
  recombineTts,
};

export default storyImagePlanService;
